import type { ReactNode } from 'react';

import { Box } from '@opendoor/atoms/box';
import { generatePresetPictureSet } from 'components/shared/performance/pictures';

import { HERO_IMAGE_DESKTOP_PROPS, HERO_IMAGE_MOBILE_PROPS } from './heroConstants';

interface HeroImagesProps {
  imageDesktopUrl?: string;
  imageMobileUrl?: string;
  lowBandwidth?: boolean;
}

// Tall arch: a 540px top radius with squared bottom corners on mobile that round
// to 36px from the SM (768px) breakpoint up. These exact radii are off the
// Tailwind radius scale, but the hero arch is a deliberate one-off so the
// arbitrary values live inline rather than in a CSS module.
const HeroImageContainer = ({ children }: { children: ReactNode }) => (
  <Box className="relative aspect-[4/5] w-full overflow-hidden rounded-t-[540px] md:rounded-b-[36px]">
    {children}
  </Box>
);

export const HeroImages = ({ imageDesktopUrl, imageMobileUrl, lowBandwidth }: HeroImagesProps) => {
  return (
    <>
      <Box className="hidden lg:block">
        {imageDesktopUrl && (
          <HeroImageContainer>
            {generatePresetPictureSet({
              ...HERO_IMAGE_DESKTOP_PROPS,
              photoUrl: imageDesktopUrl,
              preload: false,
              ...(lowBandwidth ? { quality: 50 } : {}),
            })}
          </HeroImageContainer>
        )}
      </Box>
      <Box className="block lg:hidden">
        {imageMobileUrl && (
          <HeroImageContainer>
            {generatePresetPictureSet({
              ...HERO_IMAGE_MOBILE_PROPS,
              photoUrl: imageMobileUrl,
              preload: false,
              ...(lowBandwidth ? { quality: 50 } : {}),
            })}
          </HeroImageContainer>
        )}
      </Box>
    </>
  );
};
